import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://giochinidiparole.com';

/**
 * Updates the canonical link tag to match the current page URL.
 * 
 * For dated game pages (e.g., /collegamenti/2024-12-18), the canonical
 * points to the base game URL (e.g., /collegamenti) since each day's
 * puzzle represents the same "game" for SEO purposes.
 * 
 * For all other pages, the canonical points to the exact current path.
 */
export const useCanonical = () => {
  const location = useLocation();

  useEffect(() => {
    // Determine the canonical path
    let canonicalPath = location.pathname;

    // For dated game URLs like /collegamenti/2024-12-18, use the base game URL
    // This matches the sitemap structure where only base game URLs are listed
    const datedGameMatch = canonicalPath.match(/^(\/[a-z-]+)\/\d{4}-\d{2}-\d{2}$/);
    if (datedGameMatch) {
      canonicalPath = datedGameMatch[1]; // e.g., /collegamenti
    }

    // Remove trailing slash (except for root)
    if (canonicalPath !== '/' && canonicalPath.endsWith('/')) {
      canonicalPath = canonicalPath.slice(0, -1);
    }

    const canonicalUrl = `${BASE_URL}${canonicalPath}`;
    updateCanonical(canonicalUrl);
  }, [location.pathname]);
};

/**
 * Updates the canonical link tag in the document head.
 * Creates the tag if it doesn't exist.
 */
function updateCanonical(url) {
  let link = document.querySelector('link[rel="canonical"]');
  
  if (!link) {
    link = document.createElement('link');
    link.rel = 'canonical';
    document.head.appendChild(link);
  }
  
  link.setAttribute('href', url);
}

/**
 * Component version for use in Router context.
 * Use this in App.js alongside ThemeColorUpdater.
 */
export const CanonicalUpdater = () => {
  useCanonical();
  return null;
};

export default useCanonical;

